import { useTranslation } from 'react-i18next';

import type { ButtonProps } from './Button';
import { Button } from './Button';

export function ButtonLoadMore(props: ButtonProps) {
	const { t } = useTranslation();

	return (
		<Button
			css={{
				borderColor: '#82D2FF',
				borderRadius: '1rem',
				height: '1.75rem',
				paddingLeft: '2rem',
				paddingRight: '2rem',
			}}
			{...props}
		>
			{t('buttons.loadMore')}
		</Button>
	);
}
